var Request = require('../helper/request');
var Language = require('./userSpecificationGroup/language');

function UserSpecificationGroup(app, companyId){
  var self = this;
  self.request = new Request(app);
  self.companyId = companyId;
  self.app = app;
  
  self.routes = {
    index: {
      url: '/company/'+self.companyId+'/user_specification_group',
      method: 'GET'
    },
    show: {
      url: '/company/'+self.companyId+'/user_specification_group/:id',
      method: 'GET'
    },
    create: {
      url: '/company/'+self.companyId+'/user_specification_group',
      method: 'POST'
    },
    update: {
      url: '/company/'+self.companyId+'/user_specification_group/:id',
      method: 'PUT'
    },
    delete: {
      url: '/company/'+self.companyId+'/user_specification_group/:id',
      method: 'DELETE'
    }
  };
}

UserSpecificationGroup.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

UserSpecificationGroup.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
}


UserSpecificationGroup.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    user_specification_group: data
  });
}

UserSpecificationGroup.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    user_specification_group: data
  });
}

UserSpecificationGroup.prototype.patch = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.patch(uri, {
    user_specification_group: data
  });
}

UserSpecificationGroup.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
}

UserSpecificationGroup.prototype.language = function(id){
  var self = this;
  return new Language(self.app, self.companyId, id);
}

module.exports = UserSpecificationGroup;
